import email from '../assets/email.png';
import mobile from '../assets/mobile.png';
import api from '../assets/api.png';
import cpp from '../assets/cpp.png';
import css from '../assets/css.png';
import figma from '../assets/figma.png';
import flutter from '../assets/flutter.png';
import git from '../assets/git.png';
import graphql from '../assets/graphql.png';
import html from '../assets/html.png';
import javascript from '../assets/javascript.png';
import mu5 from '../assets/mu5.png';
import node from '../assets/node.png';
import python from '../assets/python.png';
import react from '../assets/react.png';
import react1 from '../assets/react1.png';
import redux from '../assets/redux.png';
import sass from '../assets/sass.png';
import typescript from '../assets/typescript.png';
import vue from '../assets/vue.png';
import kotlin from '../assets/kotlin.png';
import java from '../assets/java.png';
import mobiledev from '../assets/mobiledev.jpg';

import about01 from '../assets/about01.png';
import about02 from '../assets/about02.png';
import about03 from '../assets/about03.png';
import about04 from '../assets/about04.png';
import product from '../assets/product.png';
import mycv from '../assets/mycv.pdf';
import reactimg from '../assets/reactimg.jpg';
import restaurant from '../assets/restaurant.png';

import profile from '../assets/profile.png';
import me from '../assets/me.png';
import circle from '../assets/circle.svg';
import logo from '../assets/logo.png';
import logo1 from '../assets/logo1.png';

import adidas from '../assets/adidas.png';
import amazon from '../assets/amazon.png';
import asus from '../assets/asus.png';
import bolt from '../assets/bolt.png';
import nb from '../assets/nb.png';
import skype from '../assets/skype.png';
import spotify from '../assets/spotify.png';

export default {
  email,
  mobile,
  api,
  cpp,
  css,
  figma,
  flutter,
  git,
  graphql,
  html,
  javascript,
  java,
  mu5,
  node,
  python,
  react,
  react1,
  redux,
  sass,
  typescript,
  vue,
  product,
  mycv,
  reactimg,
  restaurant,
  about01,
  about02,
  about03,
  about04,
  profile,
  me,
  circle,
  logo,
  logo1,
  adidas,
  amazon,
  asus,
  bolt,
  nb,
  skype,
  spotify,
  kotlin,
  mobiledev,
};